<div class="button-wrapper" *checkPermission="permissionEdit">
    <div class="group">
        <div class="inline-flex" ngbTooltip="{{'buttons.download' | translate}}" tooltipClass="animation-tooltip" placement="top" container="body"  triggers="hover"  
            *ngIf="context == 'file' && !edit">
            <button class="extra-button green" (click)="download()">
                <div class="icon fill-white" style="padding: 2px;" aria-label="csv"
                    [inlineSVG]="'assets/ico/download.svg'"></div>
            </button>
        </div>

        <div class="inline-flex" ngbTooltip="{{'buttons.edit' | translate}}" tooltipClass="animation-tooltip" placement="top" container="body"  triggers="hover"
            *ngIf="!edit && !isSave">
            <button class="extra-button yellow" (click)="editForm($event)">
                <img src="assets/ico/edit.svg" alt="edit" />
                </button>
        </div>

        <div class="inline-flex" ngbTooltip="{{'buttons.delete' | translate}}" tooltipClass="animation-tooltip" placement="top" container="body"  triggers="hover"
            *ngIf="!edit && !hideDelete">
            <app-modal-info [title]="'Confirm action'" [text]="'Are you sure to delete this item?'" [color]="'red'"
                [isQuestion]="false" iconSrc="assets/ico/trash-alt-regular.svg" (confirmEvent)="delete()"
                (dissmisModalEvent)="dissmisModal()">
                <span action (click)="preDelete()">
                    <button class="extra-button red">
                        <img src="assets/ico/trash-alt-regular.svg" alt="edit" />
                    </button>
                </span>
            </app-modal-info>
        </div>
        <span>

        </span>
        <div class="inline-flex" ngbTooltip="{{'buttons.save' | translate}}"  triggers="hover" tooltipClass="animation-tooltip" placement="top" container="body"
            *ngIf="edit">
            <button class="extra-button green" [disabled]="!form.dirty" (click)="saveForm()">
                <img class="save" src="assets/ico/save.svg" alt="save" />
                </button>
        </div>

        <div class="inline-flex" ngbTooltip="{{'buttons.undo' | translate}}" tooltipClass="animation-tooltip" placement="top" container="body"  triggers="hover"
            *ngIf="edit">
            <button class="extra-button red" (click)="cancelForm()">
                <img class="undo" src="assets/ico/undo-24px.svg" alt="back" />
            </button>
        </div>

    </div>
</div>